import ProsAndCons from 'components/ProductPage/RatingsAndReviews/ProsAndCons/ProsAndCons';

export default ProsAndCons;
